
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { useQuestItemTranslation } from '@/modules/quest/item/model/translate';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';

export default defineComponent({
    name: ROUTE_NAME_QUEST.ITEM.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, beforeFetch, actions, localeSupportedOptions } = useQuestItemTranslation();

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { v$, model, fetch, actions, localeSupportedOptions };
    }
});
